import Home from "./pages/Home/Home";
import NavBar from "./components/NavBar/NavBar";
import Footer from "./components/Footer/Footer";
import PageNotFound from "./components/PageNotFound/PageNotFound";

import "./App.scss";
import CityAreas from "./pages/CityAreas/CityAreas";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import RootPage from "./pages/RootPage";
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <NavBar />
        <Routes>
          <Route path="/" element={<RootPage />}>
            <Route index element={<Home />} />
            <Route path="/areas/:area?" element={<CityAreas />} />
          </Route>
          <Route path="*" element={<PageNotFound />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
